<script lang="ts">
  import { compileRoutes, installRouterListeners, matchRoute, subscribe, type RouteDef } from '../lib/router';

  let { routes, fallback }: { routes: RouteDef[]; fallback?: import('svelte').Snippet } = $props();

  let path = $state(window.location.pathname);

  let compiled = $derived(compileRoutes(routes));
  let match = $derived(matchRoute(path, compiled));

  $effect(() => {
    const offSub = subscribe((p) => { path = p; });
    const offListeners = installRouterListeners();
    return () => { offSub(); offListeners(); };
  });
</script>

{#if match.notFound}
  {#if fallback}
    {@render fallback()}
  {:else}
    <div class="not-found">
      <h1>404</h1>
      <p>Sivua ei löydy.</p>
      <a href="/" data-link>Takaisin tähän päivään</a>
    </div>
  {/if}
{:else if match.component}
  {@const Component = match.component}
  <Component params={match.params} />
{/if}

<style>
  .not-found {
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 24px;
    text-align: center;
  }
  .not-found h1 {
    font-size: 56px;
    font-weight: 800;
    color: var(--viisi-ink);
  }
  .not-found p { color: var(--viisi-ink-2); margin: 0; }
  .not-found a {
    margin-top: 16px;
    color: var(--viisi-accent);
    font-weight: 600;
    text-decoration: none;
  }
  .not-found a:hover { text-decoration: underline; }
</style>
